import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertCircle, FiRefreshCw, FiHome } = FiIcons;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  handleReset = () => {
    // Clear potentially corrupted data
    try {
      localStorage.removeItem('planningWithPurpose');
    } catch (e) {
      console.error('Could not clear storage:', e);
    }
    
    // Reset component state
    this.setState({ hasError: false, error: null });
    
    // Reload the page
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-cream via-soft-blue/10 to-sage-green/20 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
            <SafeIcon icon={FiAlertCircle} className="text-4xl text-red-500 mx-auto mb-4" />
            <h2 className="font-serif text-2xl text-warm-brown mb-4">
              Something went wrong
            </h2>
            <p className="text-warm-brown/70 mb-6">
              Don't worry - your writing journey can continue. Let's get you back on track.
            </p>
            <div className="space-y-3">
              <button
                onClick={this.handleReset}
                className="w-full bg-sage-green text-white py-3 rounded-xl font-medium hover:bg-sage-green/90 transition-colors flex items-center justify-center"
              >
                <SafeIcon icon={FiRefreshCw} className="mr-2" />
                Reset & Continue
              </button>
              <button
                onClick={() => window.location.reload()}
                className="w-full bg-warm-brown/10 text-warm-brown py-3 rounded-xl font-medium hover:bg-warm-brown/20 transition-colors flex items-center justify-center"
              >
                <SafeIcon icon={FiHome} className="mr-2" />
                Refresh Page
              </button>
            </div>
            <p className="text-xs text-warm-brown/50 mt-4">
              "He gives strength to the weary and increases the power of the weak." - Isaiah 40:29
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;